import React, { useEffect, useState } from "react";
import { Form, Button, Typography, Flex, Grid, Drawer, Tooltip, Select } from "antd";
import { App } from "antd";
import InputField from "../../../components/Input/Input";
import { useForm } from "antd/es/form/Form";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { saveCategory, deleteCategory } from "../categoryThunks";
import { setSelectedCategory, setIsEditCategory } from "../categorySlice";
// 👈 wherever this actually lives
import { getAccessType } from "../../../lib/functions";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { fetchItemGroups } from "../../Product_manage/itemManageThunks";
import { selectAuthInfo } from "../../Auth/authSelectors";

const { Title } = Typography;
const { useBreakpoint } = Grid;
const { Option } = Select;

const CreateCategoryForm = () => {
  const { modal } = App.useApp();
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [form] = useForm();
  let [access_type, access_type_set] = useState("");
  const [helpOpen, setHelpOpen] = useState(false);

  useEffect(() => {
    const access = getAccessType("item_category");
    access_type_set(access);
  }, []);

  const { isEditCategory, selectedCategory } = useSelector(
    (state) => state.categories
  );

  // 👈 wherever groups live in your store — adjust the slice key if different
  const { groups } = useSelector((state) => state.itemManage);
  const authInfo = useSelector(selectAuthInfo);
  const isPerfumeIndustry = authInfo?.branch_company_type === "Perfume Industry";

  useEffect(() => {
    dispatch(fetchItemGroups());
  }, [dispatch]);

  useEffect(() => {
    if (isEditCategory && selectedCategory) {
      form.setFieldsValue(selectedCategory);
    } else {
      form.resetFields();
    }
  }, [isEditCategory, selectedCategory, form]);

  const handleCancel = () => {
    dispatch(setSelectedCategory(null));
    dispatch(setIsEditCategory(false));
    navigate(-1);
  };

  const handleSave = async (values) => {
    if (!values.group_id) {
      return modal.warning({ title: "Please select a Group" });
    }

    try {
      await dispatch(
        saveCategory({
          ...values,
          action: isEditCategory ? "update" : "create",
          category_id: selectedCategory?.category_id || 0,
        })
      ).unwrap();

      modal.success({
        title: isEditCategory
          ? "Category updated successfully"
          : "Category created successfully",
      });

      dispatch(setSelectedCategory(null));
      dispatch(setIsEditCategory(false));
      navigate("/inventory/category");
    } catch (error) {
      modal.warning({
        title: error.message || "Save failed",
      });
    }
  };

  return (
    <div className="category-form">
     <Flex
        justify="space-between"
        align="center"
        style={{ marginBottom: "32px", gap: 12 }}
      >
        <Flex align="center" style={{ minWidth: 0 }}>
          <Title
            level={!screens.md ? 4 : 2}
            style={{
              margin: 0,
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            {isEditCategory ? "Update Category" : "Create New Category"}
          </Title>
        </Flex>

        <Tooltip title="Help">
          <Button
            type="text"
            icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
            onClick={() => setHelpOpen(true)}
            style={{ flexShrink: 0 }}
          />
        </Tooltip>
      </Flex>

      <Form
        form={form}
        layout="horizontal"
        onFinish={handleSave}
        variant="filled"
        style={{ maxWidth: "1400px" }}
        colon={false}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 18 }}
      >
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item
              label="Group"
              name="group_id"
              rules={[{ required: true, message: "Please select a group" }]}
            >
              <Select placeholder="Select Group" data-testid="group-select">
                {groups?.map((g) => (
                  <Option key={g.group_id} value={g.group_id}>
                    {g.group_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Category Name"
              name="category_name"
              rules={[
                { required: true, message: "Please enter category name" },
              ]}
            >
              <InputField placeholder="Enter Category Name" />
            </Form.Item>

            {isPerfumeIndustry && (
              <Form.Item
                label="Category Type"
                name="category_type"
                initialValue="general"
              >
                <Select placeholder="Select Category Type" data-testid="category-type-select">
                  <Option value="general">General</Option>
                  <Option value="raw_material">Raw Material</Option>
                  <Option value="finished_product">Finished Product</Option>
                </Select>
              </Form.Item>
            )}
          </Flex>
        </Flex>

        <Flex style={{ marginBottom: "32px", width: "25%" }} gap={32}>
          <Button
            size="large"
            shape="default"
            onClick={handleCancel}
            className="traic-button"
          >
            Back
          </Button>
          {access_type == "WRITE" && <>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              className="traic-button"
            >
              {isEditCategory ? "Update" : "Save"}
            </Button>
          </>}
        </Flex>
      </Form>
      <Drawer
        title="Category Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={420}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
              marginLeft: "8px",
            }}
          >
            Item Category
          </h2>

          <p
            style={{
              color: "#555",
              marginBottom: "16px",
              marginLeft: "8px",
            }}
          >
            The Item Category module is used to create and manage product
            categories within the ERP system. Categories help organize items
            for easier inventory management, reporting, and product grouping.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <strong>Steps to Create Category</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>Open <strong>Inventory → Category</strong></li>
              <li>Click <strong>Create New Category</strong></li>
              <li>Select the parent Group</li>
              <li>Enter category name</li>
              <li>Verify entered category details</li>
              <li>Click <strong>Save</strong> to create the category</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: "18px",
                marginTop: "10px",
                color: "#666",
              }}
            >
              <li>Every category must belong to a Group.</li>
              <li>Category names should be unique within a Group.</li>
              <li>Categories help simplify inventory reporting and filtering.</li>
              <li>Existing categories can be updated later if required.</li>
              <li>Items can be grouped under categories for easier management.</li>
            </ul>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default CreateCategoryForm;